// Side-effecting source bootstrap — importing this module registers
// every available source with the lorem registry.
//
// Sources themselves stay lazy (the loader functions return a Promise
// that resolves on first generate() call) so this import is cheap.

import { registerSource } from "../registry";
import { loadLoremClassical } from "./lorem-classical";
import { loadLoremMath } from "./lorem-math";
import { loadLoremTech } from "./lorem-tech";

registerSource("lorem", loadLoremClassical);
registerSource("lorem-tech", loadLoremTech);
registerSource("lorem-math", loadLoremMath);
